/**
 * Component Registry for 1221 Broadway Lofts
 *
 * Inherits from @vibesites-mox/theme-theme-prestige and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-mox/theme-theme-prestige/registry';
import { Header } from './components/Header';
import { HeroSolidBG } from './components/HeroSolidBG';
import { LifestyleTestimonials } from './components/LifestyleTestimonials';
import { CobuEmbed } from './components/CobuEmbed';

/**
 * Property-specific component overrides and additions.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  HeroSolidBG,
  LifestyleTestimonials,
  CobuEmbed,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
